/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GetUsersRequest {
  pageIndex: number;
  pageSize: number;
  search: string | null;
}

export interface Users {
  id: string;
  nome: string;
  email: string;
  roles: string[];
}

export interface GetUsersResponse {
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  indexFrom: number;
  items: Users[];
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

interface State {
  isRequesting: boolean;
  lastRequest: GetUsersRequest | null;
  successPayload: GetUsersResponse;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  lastRequest: null,
  successPayload: {
    pageIndex: 0,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
    indexFrom: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  errors: [],
};

const getUsersPaginatedSlice = createSlice({
  name: "users@getUsersPaginated",
  initialState,
  reducers: {
    getUsersPaginated: (
      state,
      action: PayloadAction<GetUsersRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
      state.lastRequest = {
        ...action.payload,
      };
    },
    getUsersPaginatedSuccess: (
      state,
      action: PayloadAction<GetUsersResponse>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    getUsersPaginatedFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    },
  },
});

export const {
  getUsersPaginated,
  getUsersPaginatedSuccess,
  getUsersPaginatedFailed,
} = getUsersPaginatedSlice.actions;
export default getUsersPaginatedSlice.reducer;
